<template>
  <md-field md-clearable @md-clear="clearValue" class="md-invalid month-picker">
    <div class="w-full relative cursor-pointer">
      <div class="w-full h-full flex">
        <label>{{ $t(label) }}</label>
        <md-input
          :disabled="disabled"
          v-model="monthPicker"
          :required="required"
          readonly
        ></md-input>
        <slot></slot>
      </div>
      <date-picker
        :disabled="disabled"
        v-model="monthPicker"
        type="month"
        format="MM-YYYY"
        value-type="format"
        @change="changeValue($event)"
        ref="monthPicker"
      ></date-picker>
    </div>
  </md-field>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";

export default {
  name: "date-picker-custom",
  components: { DatePicker },
  props: {
    label: String,
    required: {
      type: Boolean,
      default: false
    },
    value: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  computed: {
    monthPicker: {
      get: function() {
        return moment(this.value).format("MM-YYYY");
      },
      set: function(value) {
        return value;
      }
    }
  },
  methods: {
    changeValue(newValue) {
      if (newValue) {
        this.$emit("change", moment(newValue, "MM-YYYY").format("YYYY-MM"));
      } else {
        this.clearValue();
      }
    },
    clearValue() {
      this.monthPicker = "";
      this.$emit("change", "");
    }
  }
};
</script>
<style lang="scss">
.month-picker {
  .mx-datepicker {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;

    input.mx-input {
      background: transparent;
      border: 0;
      box-shadow: none;
      color: transparent;
      cursor: pointer;
    }
    .mx-icon-clear {
      color: transparent;
    }
  }

  .md-error {
    top: 35px;
  }

  button[disabled="disabled"].md-clear {
    display: none;
  }
}
</style>
